import * as React from "react";
const SvgMaximize24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 24,
        fill: "black",
        viewBox: "0 0 25 24"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2.5 2h8v2h-6v6h-2V2Zm18 2h-6V2h8v8h-2V4Zm-16 16v-6h-2v8h8v-2h-6Zm16 0v-6h2v8h-8v-2h6Z",
      clipRule: "evenodd"
    })
  );
export default SvgMaximize24Px;
